import axios from 'axios'
import { bankUrl, getHeader } from '@/config'

const state = {
  bankList: [],
  paymentMethodList: []
}

const mutations = {
  SET_BANK_LIST (state, data) {
    state.bankList = data
  },
  SET_PAYMENT_METHOD_LIST (state, data) {
    state.paymentMethodList = data
  }
}

const actions = {
  getBankList: ({ commit }) => {
    axios.get(bankUrl, { headers: getHeader() })
      .then(response => {
        console.log(response.data.message)
        commit('SET_BANK_LIST', response.data.data)
      })
  },
  getBankPaymentMethodList: ({ commit }) => {
    axios.get(bankUrl, { headers: getHeader() })
      .then(response => {
        var loop = [{
          name: 'Cash',
          method: 'cash',
          bank_id: null,
          active: false
        }]
        var array = response.data.data
        for (let i = 0; i < array.length; i++) {
          var obj = {
            name: array[i].name,
            method: 'transfer',
            bank_id: array[i].id,
            active: false
          }
          loop.push(obj)
        }
        commit('SET_PAYMENT_METHOD_LIST', loop)
      })
  }
}

export default {
  state, mutations, actions
}
